module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/image-dff6c6c7d2b00ab948ba8007754c2b1d.svg";